import { createSelector } from '@ngrx/store';
import * as fromFeature from '@app/shared/store/reducers';
import * as fromCities from '@app/shared/store/reducers/city.reducers';

export const selectCityState = createSelector(
  fromFeature.selectSharedFeatureState,
  (state: fromFeature.State) => state.cities
);

export const getCities = createSelector(selectCityState, fromCities.getCities);
